exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-select-dropdown__item span:before {\n  position: relative;\n  margin-left: -14px;\n  margin-right: 4px;\n  padding: 2px;\n  font-size: 1.2em;\n  text-shadow: 0px 0px 2px;\n  color: green;\n  font-weight: bold;\n  content: '+';\n}\n.largefit .el-input__inner {\n  height: auto !important;\n  line-height: 42px !important;\n}\n.largefit .el-input--suffix .el-input__inner {\n  padding-right: auto !important;\n}\n", ""]);

// exports
